


































import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseCard from "@/components/BaseCard";
import FormatMoney from "@/components/FormatMoney/FormatMoney.vue";
import TextClamp from "@/components/TextClamp/TextClamp.vue";

export default defineComponent({
  name: "CardCost",
  components: { BaseCard, FormatMoney, TextClamp, BaseButton },
  props: {
    buttonText: { type: String, required: true },
    description: { type: String },
    processing: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    gradient: { type: Boolean, default: false },
    deposit: { type: Boolean, default: false },
    cost: { type: Number, required: true },
    contentCount: { type: Number },
  },
});
